import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { theme } from './theme';

import Ditor from './Components/Ditor.jsx';
import Header from './Components/Header.jsx';
import LandingPage from './Components/LandingPage.jsx';

// Wrapper component for the editor page
const EditorPage = () => {
  const navigate = useNavigate();
  
  const handleBackToLanding = () => {
    navigate('/');
  };

  return (
    <div className="h-screen overflow-hidden">
      <Header onBackToLanding={handleBackToLanding} />
      <Ditor />
    </div>
  );
};

function App() {
  return (
    <Router>
      <div 
        style={{ backgroundColor: theme.colors.bg.primary }}
      >
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/editor" element={<EditorPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;